import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';

const ProjectCarousel = ({ images, imageTitles, title, category }) => {
  return (
    <div className="group relative overflow-hidden">
      <Carousel className="w-full">
        <CarouselContent>
          {images.map((image, index) => (
            <CarouselItem key={index}>
              <div className="aspect-[4/3] overflow-hidden bg-gray-900 relative">
                <img 
                  src={image} 
                  alt={`${title} - Image ${index + 1}`}
                  className="w-full h-full object-cover"
                  style={index === 0 ? { objectPosition: '40% center' } : {}}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
                
                {/* Image Title in Top Right Corner */}
                {imageTitles && imageTitles[index] && (
                  <div className="absolute top-4 right-4 bg-black/80 px-4 py-2 border-l-2 border-gold max-w-xs">
                    <p className="text-white text-sm font-medium leading-tight">
                      {imageTitles[index]}
                    </p>
                  </div>
                )}
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        
        {/* Custom Navigation Buttons */}
        <CarouselPrevious className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 border-gold hover:bg-gold hover:text-black transition-all duration-300 opacity-0 group-hover:opacity-100" />
        <CarouselNext className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 border-gold hover:bg-gold hover:text-black transition-all duration-300 opacity-0 group-hover:opacity-100" />
      </Carousel>
      
      {/* Project Info Overlay */}
      <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-playfair text-2xl font-bold">{title}</h3>
          </div>
        </div>
      </div>
      
      {/* Image Counter */}
      <div className="absolute top-4 right-4 bg-black/70 px-3 py-1 text-xs text-gold border border-gold/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        {images.length} IMAGES
      </div>
    </div>
  );
};

export default ProjectCarousel;
